import { useController } from "react-hook-form"
import { Label } from "components/atoms/form"

export const Input = (props) => {
  const {
    field: { value, onChange, ref },
    fieldState: { error },
  } = useController({
    ...props,
    rules: {
      required: props.required,
    },
  })

  const { label, required, type, placeholder, defaultValue } = props
  return (
    <div className="block w-full sm:inline-flex">
      <div className="w-full">
        <Label label={label} required={required} error={error} />
        <input
          ref={ref}
          placeholder={placeholder}
          value={value}
          type={type}
          defaultValue={defaultValue}
          onChange={onChange}
          className="relative z-0 inline-flex h-10 w-full appearance-none rounded-lg border border-zinc-300 bg-white px-3 py-2 pl-3 pr-8 text-left text-sm leading-normal text-zinc-800 focus:border-0 focus:ring-2 focus:ring-blue-600"
        />
      </div>
    </div>
  )
}
